import { render, staticRenderFns } from "./ManageSeminarParticipantPositions.vue?vue&type=template&id=99ce3f7a&scoped=true&"
import script from "./ManageSeminarParticipantPositions.vue?vue&type=script&lang=js&"
export * from "./ManageSeminarParticipantPositions.vue?vue&type=script&lang=js&"
import style0 from "./ManageSeminarParticipantPositions.vue?vue&type=style&index=0&id=99ce3f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ce3f7a",
  null
  
)

export default component.exports